/*
  Figma "Page header": the raised block that opens most screens. Eyebrow in
  Caps/Label, title in Title 2, subtitle in Subheadline, an optional action on
  the end.
*/
const PageHeader = ({ eyebrow, title, subtitle, action = null, className = "" }) => (
  <header
    className={`flex items-center gap-space-16 rounded-radius-xl border border-separator-default bg-bg-raised px-space-24 py-space-20 ${className}`}
  >
    <div className="flex min-w-0 flex-1 flex-col gap-space-4">
      {eyebrow && <p className="text-caps-label uppercase text-label-secondary">{eyebrow}</p>}
      <h1 className="text-title-2 text-label-primary">{title}</h1>
      {subtitle && <p className="text-subheadline text-label-secondary">{subtitle}</p>}
    </div>
    {action}
  </header>
);

export default PageHeader;
